import { render } from "./PenilaianLKE.vue?vue&type=template&id=8cba3b5c"
import script from "./PenilaianLKE.vue?vue&type=script&lang=js"
export * from "./PenilaianLKE.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__